// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var DataType$ReactHooksTemplate = require("../data_fields/dataType.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var CustomerInfo$ReactHooksTemplate = require("../surveys/CustomerInfo.res.js");

function escapeHtml(s) {
  if (s === "") {
    return "";
  } else {
    return Js_string.replaceByRe(new RegExp("'", "g"), "&#x27;", Js_string.replaceByRe(new RegExp("\"", "g"), "&quot;", Js_string.replaceByRe(new RegExp(">", "g"), "&gt;", Js_string.replaceByRe(new RegExp("<", "g"), "&lt;", Js_string.replaceByRe(new RegExp("&", "g"), "&amp;", s)))));
  }
}

function substituteVariables(text, variables) {
  var entries = Js_dict.entries(variables);
  return Belt_Array.reduce(entries, text, (function (acc, entry) {
                var placeholder = "${" + entry[0] + "}";
                var safeValue = escapeHtml(entry[1]);
                return Js_array.joinWith(safeValue, Js_string.split(placeholder, acc));
              }));
}

function sanitizeRichText(html) {
  return html;
}

var renderQuestionText = substituteVariables;

function buildSubstitutionMap(dataFields) {
  var dict = {};
  Belt_List.forEach(dataFields, (function (df) {
          var key = DataField$ReactHooksTemplate.name(df);
          var v = DataType$ReactHooksTemplate.valueAsString(DataField$ReactHooksTemplate.dataType(df));
          var value = v !== undefined ? v : "";
          dict[key] = value;
        }));
  return dict;
}

function buildSubstitutionMapWithPriority(dataFields, customerInfo) {
  var dataMap = buildSubstitutionMap(dataFields);
  var dict = {};
  var rmNameVal = CustomerInfo$ReactHooksTemplate.rmName(customerInfo);
  dict["rm_name"] = rmNameVal;
  dict["RM_NAME"] = rmNameVal;
  var entries = Js_dict.entries(dataMap);
  Belt_Array.forEach(entries, (function (param) {
          var key = param[0];
          if (key !== "rm_name" && key !== "RM_NAME") {
            dict[key] = param[1];
            return ;
          }
          
        }));
  return dict;
}

exports.escapeHtml = escapeHtml;
exports.substituteVariables = substituteVariables;
exports.sanitizeRichText = sanitizeRichText;
exports.renderQuestionText = renderQuestionText;
exports.buildSubstitutionMap = buildSubstitutionMap;
exports.buildSubstitutionMapWithPriority = buildSubstitutionMapWithPriority;
/* DataType-ReactHooksTemplate Not a pure module */
